import { companyStart, companySuccess, companyFailure, updateStart, updateSuccess, updateFailure } from "../../reducers/master/editCompanyRedux";
import { publicRequest } from "../../../requestMeth"; 


export const getCompany = async (dispatch, id, token, typeQ) => {
    dispatch(companyStart());
    try {
        const res = await publicRequest.get(`/master/company/${id}?type=${typeQ}`, {
            headers: { token: `Bearer ${token}` }
        });
        dispatch(companySuccess(res.data));
        
        return res.data
    } catch (error) {
        dispatch(companyFailure());
    }
  };

export const updateCompany = async (dispatch, id, payload, token, typeQ) => {
    dispatch(updateStart());
    try {
        const res = await publicRequest.put(`/master/company/edit/${id}?type=${typeQ}`, payload, {
            headers: { token: `Bearer ${token}` }
        });
        dispatch(updateSuccess(res.data));
        return res.data;
    } catch (error) {
        dispatch(updateFailure());
        throw error;
    }
};